import { render, staticRenderFns } from "./mainassist.vue?vue&type=template&id=34deeab0&scoped=true&"
import script from "./mainassist.vue?vue&type=script&lang=js&"
export * from "./mainassist.vue?vue&type=script&lang=js&"
import style0 from "./mainassist.vue?vue&type=style&index=0&id=34deeab0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34deeab0",
  null
  
)

export default component.exports